import { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

import CustomInput from '../common/CustomInput';
import colors from '../../assets/colors';
import { farm } from '../../utils/api';
import FarmContext from '../../store/farm-context';

export default function SimpleFarmSelect(props) {
  const [farms, setFarms] = useState(null);
  const farmCTX = useContext(FarmContext);
  const changeFarm = (event) => {
    farmCTX.setFarmID(event.target.value);
    if (props.onChange) props.onChange();
  };
  const history = useHistory();

  useEffect(() => {
    farm
      .all()
      .then((result) => {
        if (result.status === 200) {
          if (farmCTX.farmID == null && result.data[0]) {
            farmCTX.setFarmID(result.data[0].id);
          } else if (!result.data[0]) {
            farmCTX.clearFarmID();
          } else if (farmCTX.farmID !== null) {
            if (!checkIfFarmIDValid(result.data)) farmCTX.clearFarmID();
          }
          setFarms(result.data);
        } else {
          history.push('/login');
        }
      })
      .catch((err) => {
        try {
          if (err.response.status === 403) {
            history.push('/login');
          }
        } catch (e) {}
      });
    // eslint-disable-next-line
  }, []);

  const checkIfFarmIDValid = (data) => {
    const idArray = data.map((data) => data.id);
    return idArray.includes(farmCTX.farmID);
  };

  return (
    <FormControl fullWidth>
      <InputLabel>Lista gospodarstw</InputLabel>
      <Select
        aria-label="select button"
        label="Lista gospodarstw"
        input={<CustomInput />}
        value={farms?.length > 0 ? farmCTX.farmID ?? '' : ''}
        sx={{
          textAlign: 'center',
          mb: 2,
          '& 	.MuiInputBase-input': {
            backgroundColor: colors.rowLight,
          },
          maxWidth: props.maxSelectWidth,
        }}
        onChange={changeFarm}
      >
        {farms?.map((farm) => (
          <MenuItem value={farm.id} key={farm.id}>
            {farm.farmName + ' ' + farm.name + ' ' + farm.surname}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
